window.$    = window.jQuery = require('jquery');
var mask    = require('jquery-mask-plugin');
$.mask      = mask;
window.mask = mask;

export function inputsMask() {
    
    var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        optionsTelCel = {
            onKeyPress: function (val, e, field, optionsTelCel) {
                field.mask(maskBehavior.apply({}, arguments), optionsTelCel);
            }
        }; 

    $(".phone").mask(maskBehavior, optionsTelCel);  
    $('.cpf').mask('999.999.999-99');
    $('.cep').mask('99999-999');
}